import Modal from '../../components/Modal';
import { useContext, useState } from 'react';
import Question from '../../components/forms/Question';
import usePublicPostApi from '../lib/usePublicPostApi.js';
import ThemedForm from '../../components/forms/ThemedForm.jsx';
import { ConfirmationContext } from '~/lib/ConfirmationContext.js';
import { isEqual } from 'date-fns';
import ErrorMessageBlock from '~/components/ErrorMessageBlock';
import {
    clientFormatDateLong,
    clientFormatDateTimeLong,
} from '~/public/lib/ClientDateTime.js';
import FormContextProvider from '~/components/forms/FormContext.jsx';

const RescheduleButton = ({
    event,
    token,
    className,
    btnClassName,
    form,
    settings,
}) => {
    const { schedulingSettings } = useContext(ConfirmationContext);

    const [isOpen, setIsOpen] = useState(false);

    const [schedulingData, setSchedulingData] = useState({
        bookableResource:
            event.all_bookable_resource_ids || event.bookable_resource.id,
        eventType: event.event_type.id,
        //startTime: event.client_start
    });

    const { save, isSaving } = usePublicPostApi(
        `/event/${token}/${event.id}/reschedule`,
    );

    function doReschedule() {
        save({
            startTime: schedulingData[0].startTime,
            bookableResource: schedulingData[0].bookableResource,
            ignoreEvents: [event.id],
        }).then(result => {
            window.location.reload();
        });
    }

    const isReschedulingToSameTime = isEqual(
        schedulingData[0]?.startTime,
        event.client_start,
    );

    return (
        <div className={className}>
            <button
                type="button"
                className={btnClassName}
                onClick={() => setIsOpen(true)}
            >
                Reschedule
            </button>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
                <FormContextProvider
                    businessId={form?.business_id}
                    formId={form?.id}
                    formData={{}}
                    setFormData={() => null}
                    sections={[]}
                >
                    <ThemedForm styles={form?.settings?.styles}>
                        <h2>Reschedule</h2>
                        <div className="mr-6 mt-6">
                            Reschedule this from{' '}
                            <span className={'font-semibold'}>
                                {event?.event_type?.is_all_day
                                    ? clientFormatDateLong(
                                          event.client_start,
                                          event.client_timezone,
                                      )
                                    : clientFormatDateTimeLong(
                                          event.client_start,
                                          event.client_timezone,
                                      )}{' '}
                            </span>
                            to:
                        </div>
                        <Question
                            isReadOnly={false}
                            value={schedulingData}
                            setValue={setSchedulingData}
                            question={{
                                type: 'scheduling',
                                settings: {
                                    ...schedulingSettings,
                                    eventTypes: undefined,
                                    ignoreEvents: [event.id],
                                    hideEventType: true,
                                    hideBookableResource:
                                        !!settings?.allowReschedulingResource
                                            ? false
                                            : true,
                                    enableRecurring: false,
                                },
                            }}
                        />

                        {isReschedulingToSameTime && (
                            <ErrorMessageBlock className="mb-4">
                                The selected time is the same as your current
                                appointment. Please choose a different time to
                                reschedule.
                            </ErrorMessageBlock>
                        )}

                        {!!schedulingData[0]?.startTime && (
                            <button
                                type="button"
                                className={`form-button ${isReschedulingToSameTime ? 'opacity-50' : ''}`}
                                onClick={doReschedule}
                                disabled={isReschedulingToSameTime}
                            >
                                {isSaving ? 'Rescheduling...' : 'Reschedule'}
                            </button>
                        )}
                    </ThemedForm>
                </FormContextProvider>
            </Modal>
        </div>
    );
};

export default RescheduleButton;
